/**
 * VTracer WASM Loader — Self-hosted version for Shopify themes
 * Converted from vectortracer ES module (externref build) to IIFE with manual WASM loading.
 * Exposes window.VTracer.BinaryImageConverter after WASM loads.
 * Source: https://github.com/AlansCodeLog/vectortracer (MIT license)
 */
(function() {
  'use strict';

  // ── Text encoder / decoder ────────────────────────────────────────────

  var cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
  cachedTextDecoder.decode();
  var MAX_SAFARI_DECODE_BYTES = 2146435072;
  var numBytesDecoded = 0;

  function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
      cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
      cachedTextDecoder.decode();
      numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
  }

  var cachedTextEncoder = new TextEncoder();

  if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function(arg, view) {
      var buf = cachedTextEncoder.encode(arg);
      view.set(buf);
      return { read: arg.length, written: buf.length };
    };
  }

  // ── WASM state ────────────────────────────────────────────────────────

  var WASM_VECTOR_LEN = 0;
  var wasmModule, wasm;

  // ── Memory view helpers ───────────────────────────────────────────────

  var cachedUint8ArrayMemory0 = null;
  function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
      cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
  }

  var cachedDataViewMemory0 = null;
  function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
      cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
  }

  // ── String / array helpers ────────────────────────────────────────────

  function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return decodeText(ptr, len);
  }

  function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
  }

  function isLikeNone(x) {
    return x === undefined || x === null;
  }

  function passArray8ToWasm0(arg, malloc) {
    var ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8ArrayMemory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
  }

  function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
      var buf = cachedTextEncoder.encode(arg);
      var ptr = malloc(buf.length, 1) >>> 0;
      getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
      WASM_VECTOR_LEN = buf.length;
      return ptr;
    }

    var len = arg.length;
    var ptr = malloc(len, 1) >>> 0;
    var mem = getUint8ArrayMemory0();
    var offset = 0;

    for (; offset < len; offset++) {
      var code = arg.charCodeAt(offset);
      if (code > 0x7F) break;
      mem[ptr + offset] = code;
    }
    if (offset !== len) {
      if (offset !== 0) {
        arg = arg.slice(offset);
      }
      ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
      var view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
      var ret = cachedTextEncoder.encodeInto(arg, view);
      offset += ret.written;
      ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
  }

  // ── debugString (used by __wbindgen_debug_string) ─────────────────────

  function debugString(val) {
    var type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
      return '' + val;
    }
    if (type == 'string') {
      return '"' + val + '"';
    }
    if (type == 'symbol') {
      var description = val.description;
      if (description == null) {
        return 'Symbol';
      } else {
        return 'Symbol(' + description + ')';
      }
    }
    if (type == 'function') {
      var name = val.name;
      if (typeof name == 'string' && name.length > 0) {
        return 'Function(' + name + ')';
      } else {
        return 'Function';
      }
    }
    if (Array.isArray(val)) {
      var length = val.length;
      var debug = '[';
      if (length > 0) {
        debug += debugString(val[0]);
      }
      for (var i = 1; i < length; i++) {
        debug += ', ' + debugString(val[i]);
      }
      debug += ']';
      return debug;
    }
    var builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    var className;
    if (builtInMatches && builtInMatches.length > 1) {
      className = builtInMatches[1];
    } else {
      return toString.call(val);
    }
    if (className == 'Object') {
      try {
        return 'Object(' + JSON.stringify(val) + ')';
      } catch (_) {
        return 'Object';
      }
    }
    if (val instanceof Error) {
      return val.name + ': ' + val.message + '\n' + val.stack;
    }
    return className;
  }

  // ── BinaryImageConverterFinalization ──────────────────────────────────

  var BinaryImageConverterFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: function() {}, unregister: function() {} }
    : new FinalizationRegistry(function(ptr) { wasm.__wbg_binaryimageconverter_free(ptr >>> 0, 1); });

  // ── BinaryImageConverter class ────────────────────────────────────────

  function BinaryImageConverter(imageData, converterOptions, options) {
    var ret = wasm.binaryimageconverter_new(imageData, converterOptions, options);
    this.__wbg_ptr = ret >>> 0;
    BinaryImageConverterFinalization.register(this, this.__wbg_ptr, this);
    return this;
  }

  BinaryImageConverter.prototype.__destroy_into_raw = function() {
    var ptr = this.__wbg_ptr;
    this.__wbg_ptr = 0;
    BinaryImageConverterFinalization.unregister(this);
    return ptr;
  };

  BinaryImageConverter.prototype.free = function() {
    var ptr = this.__destroy_into_raw();
    wasm.__wbg_binaryimageconverter_free(ptr, 0);
  };

  BinaryImageConverter.prototype.getResult = function() {
    var deferred1_0;
    var deferred1_1;
    try {
      var ret = wasm.binaryimageconverter_getResult(this.__wbg_ptr);
      deferred1_0 = ret[0];
      deferred1_1 = ret[1];
      return getStringFromWasm0(ret[0], ret[1]);
    } finally {
      wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
  };

  BinaryImageConverter.prototype.init = function() {
    wasm.binaryimageconverter_init(this.__wbg_ptr);
  };

  BinaryImageConverter.prototype.tick = function() {
    var ret = wasm.binaryimageconverter_tick(this.__wbg_ptr);
    return ret !== 0;
  };

  BinaryImageConverter.prototype.progress = function() {
    var ret = wasm.binaryimageconverter_progress(this.__wbg_ptr);
    return ret >>> 0;
  };

  if (Symbol.dispose) {
    BinaryImageConverter.prototype[Symbol.dispose] = BinaryImageConverter.prototype.free;
  }

  // ── WASM import object ────────────────────────────────────────────────
  // These function names (with hash suffixes) must match the new WASM binary exactly.

  function __wbg_get_imports() {
    var import0 = {
      __proto__: null,
      __wbg_Error_83742b46f01ce22d: function(arg0, arg1) {
        var ret = Error(getStringFromWasm0(arg0, arg1));
        return ret;
      },
      __wbg_String_b51de6b05a10845b: function(arg0, arg1) {
        var ret = String(arg1);
        var ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
      },
      __wbg___wbindgen_bigint_get_as_i64_447a76b5c6ef7bda: function(arg0, arg1) {
        var v = arg1;
        var ret = typeof(v) === 'bigint' ? v : undefined;
        getDataViewMemory0().setBigInt64(arg0 + 8 * 1, isLikeNone(ret) ? BigInt(0) : ret, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
      },
      __wbg___wbindgen_boolean_get_c0f3f60bac5a78d1: function(arg0) {
        var v = arg0;
        var ret = typeof(v) === 'boolean' ? v : undefined;
        return isLikeNone(ret) ? 0xFFFFFF : ret ? 1 : 0;
      },
      __wbg___wbindgen_debug_string_5398f5bb970e0daa: function(arg0, arg1) {
        var ret = debugString(arg1);
        var ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
      },
      __wbg___wbindgen_in_41dbb8413020e076: function(arg0, arg1) {
        var ret = arg0 in arg1;
        return ret;
      },
      __wbg___wbindgen_is_bigint_e2141d4f045b7eda: function(arg0) {
        var ret = typeof(arg0) === 'bigint';
        return ret;
      },
      __wbg___wbindgen_is_object_781bc9f159099513: function(arg0) {
        var val = arg0;
        var ret = typeof(val) === 'object' && val !== null;
        return ret;
      },
      __wbg___wbindgen_is_undefined_52709e72fb9f179c: function(arg0) {
        var ret = arg0 === undefined;
        return ret;
      },
      __wbg___wbindgen_jsval_eq_ee31bfad3e536463: function(arg0, arg1) {
        var ret = arg0 === arg1;
        return ret;
      },
      __wbg___wbindgen_jsval_loose_eq_5bcc3bed3c69e72b: function(arg0, arg1) {
        var ret = arg0 == arg1;
        return ret;
      },
      __wbg___wbindgen_number_get_34bb9d9dcfa21373: function(arg0, arg1) {
        var obj = arg1;
        var ret = typeof(obj) === 'number' ? obj : undefined;
        getDataViewMemory0().setFloat64(arg0 + 8 * 1, isLikeNone(ret) ? 0 : ret, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
      },
      __wbg___wbindgen_string_get_395e606bd0ee4427: function(arg0, arg1) {
        var obj = arg1;
        var ret = typeof(obj) === 'string' ? obj : undefined;
        var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
      },
      __wbg___wbindgen_throw_6ddd609b62940d55: function(arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
      },
      __wbg_data_40ab3982572daa21: function(arg0, arg1) {
        var ret = arg1.data;
        var ptr1 = passArray8ToWasm0(ret, wasm.__wbindgen_malloc);
        var len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
      },
      __wbg_debug_271c16e6de0bc226: function(arg0, arg1, arg2, arg3) {
        console.debug(arg0, arg1, arg2, arg3);
      },
      __wbg_error_1eece6b0039034ce: function(arg0, arg1, arg2, arg3) {
        console.error(arg0, arg1, arg2, arg3);
      },
      __wbg_error_a6fa202b58aa1cd3: function(arg0, arg1) {
        var deferred0_0;
        var deferred0_1;
        try {
          deferred0_0 = arg0;
          deferred0_1 = arg1;
          console.error(getStringFromWasm0(arg0, arg1));
        } finally {
          wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
        }
      },
      __wbg_get_with_ref_key_f64427178466f623: function(arg0, arg1) {
        var ret = arg0[arg1];
        return ret;
      },
      __wbg_height_05531443b91baa6e: function(arg0) {
        var ret = arg0.height;
        return ret;
      },
      __wbg_info_0194681687b5ab04: function(arg0, arg1, arg2, arg3) {
        console.info(arg0, arg1, arg2, arg3);
      },
      __wbg_instanceof_ArrayBuffer_101e2bf31071a9f6: function(arg0) {
        var result;
        try {
          result = arg0 instanceof ArrayBuffer;
        } catch (_) {
          result = false;
        }
        var ret = result;
        return ret;
      },
      __wbg_instanceof_Uint8Array_740438561a5b956d: function(arg0) {
        var result;
        try {
          result = arg0 instanceof Uint8Array;
        } catch (_) {
          result = false;
        }
        var ret = result;
        return ret;
      },
      __wbg_isSafeInteger_ecd6a7f9c3e053cd: function(arg0) {
        var ret = Number.isSafeInteger(arg0);
        return ret;
      },
      __wbg_length_ea16607d7b61445b: function(arg0) {
        var ret = arg0.length;
        return ret;
      },
      __wbg_log_524eedafa26daa59: function(arg0) {
        console.log(arg0);
      },
      __wbg_log_70972330cfc941dd: function(arg0, arg1, arg2, arg3) {
        console.log(arg0, arg1, arg2, arg3);
      },
      __wbg_new_227d7c05414eb861: function() {
        var ret = new Error();
        return ret;
      },
      __wbg_new_5f486cdf45a04d78: function(arg0) {
        var ret = new Uint8Array(arg0);
        return ret;
      },
      __wbg_prototypesetcall_d62e5099504357e6: function(arg0, arg1, arg2) {
        Uint8Array.prototype.set.call(getArrayU8FromWasm0(arg0, arg1), arg2);
      },
      __wbg_stack_3b0d974bbf31e44f: function(arg0, arg1) {
        var ret = arg1.stack;
        var ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
      },
      __wbg_warn_809cad1bfc2b3a42: function(arg0, arg1, arg2, arg3) {
        console.warn(arg0, arg1, arg2, arg3);
      },
      __wbg_width_6a767700990b90f4: function(arg0) {
        var ret = arg0.width;
        return ret;
      },
      __wbindgen_cast_0000000000000001: function(arg0, arg1) {
        var ret = getStringFromWasm0(arg0, arg1);
        return ret;
      },
      __wbindgen_cast_0000000000000002: function(arg0) {
        var ret = BigInt.asUintN(64, arg0);
        return ret;
      },
      __wbindgen_init_externref_table: function() {
        var table = wasm.__wbindgen_externrefs;
        var offset = table.grow(4);
        table.set(0, undefined);
        table.set(offset + 0, undefined);
        table.set(offset + 1, null);
        table.set(offset + 2, true);
        table.set(offset + 3, false);
      }
    };
    return {
      __proto__: null,
      './vectortracer_bg.js': import0
    };
  }

  // ── WASM finalization ─────────────────────────────────────────────────

  function __wbg_finalize_init(instance, module) {
    wasm = instance.exports;
    wasmModule = module;
    cachedDataViewMemory0 = null;
    cachedUint8ArrayMemory0 = null;
    wasm.__wbindgen_start();
    return wasm;
  }

  // ── WASM loader (streaming with fallback) ─────────────────────────────

  function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
      if (typeof WebAssembly.instantiateStreaming === 'function') {
        return WebAssembly.instantiateStreaming(module, imports)
          .catch(function(e) {
            if (module.ok && expectedResponseType(module.type) && module.headers.get('Content-Type') !== 'application/wasm') {
              console.warn('`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n', e);
              return module.arrayBuffer().then(function(bytes) {
                return WebAssembly.instantiate(bytes, imports);
              });
            }
            throw e;
          });
      }
      return module.arrayBuffer().then(function(bytes) {
        return WebAssembly.instantiate(bytes, imports);
      });
    } else {
      return WebAssembly.instantiate(module, imports).then(function(instance) {
        if (instance instanceof WebAssembly.Instance) {
          return { instance: instance, module: module };
        }
        return instance;
      });
    }

    function expectedResponseType(type) {
      switch (type) {
        case 'basic': case 'cors': case 'default': return true;
      }
      return false;
    }
  }

  // ── Load WASM and expose VTracer on window ────────────────────────────

  var _resolveReady;
  window.VTracerReady = new Promise(function(resolve) { _resolveReady = resolve; });

  var wasmUrl = window.__vtracerWasmUrl;
  if (wasmUrl) {
    var imports = __wbg_get_imports();

    fetch(wasmUrl)
      .then(function(response) {
        if (!response.ok) throw new Error('Failed to fetch WASM: ' + response.status);
        return __wbg_load(response, imports);
      })
      .then(function(result) {
        __wbg_finalize_init(result.instance, result.module);
        window.VTracer = { BinaryImageConverter: BinaryImageConverter };
        console.log('VTracer WASM loaded successfully');
        _resolveReady(true);
      })
      .catch(function(err) {
        console.warn('VTracer WASM failed to load:', err.message);
        _resolveReady(false);
      });
  } else {
    _resolveReady(false);
  }
})();
